import styled from '@emotion/styled';

export const LabelStyled = styled.div`
  width: auto;
  max-width: 200px;
  min-width: 100px;
`;
